import { PhoneCallEventType } from './phone-call-event-type.enum';
import { UserBuilder } from '../../../../common/users/user-builder';
import { ItemType } from '../../../../common/misc/item-type.enum';
import { RandomGenerator } from '../../../../../test-utils';
var PhoneCallEventBuilder = /** @class */ (function () {
    function PhoneCallEventBuilder() {
        this.phoneCallEvent = {
            id: RandomGenerator.randomId(),
            itemId: RandomGenerator.randomId(),
            itemType: ItemType.PHONE_CALL,
            eventType: PhoneCallEventType.PHONE_CALL_STARTED,
            user: new UserBuilder().build(),
            creationDate: Date.now()
        };
    }
    PhoneCallEventBuilder.prototype.withId = function (id) {
        this.phoneCallEvent.id = id;
        return this;
    };
    PhoneCallEventBuilder.prototype.withItemId = function (itemId) {
        this.phoneCallEvent.itemId = itemId;
        return this;
    };
    PhoneCallEventBuilder.prototype.withEventType = function (eventType) {
        this.phoneCallEvent.eventType = eventType;
        return this;
    };
    PhoneCallEventBuilder.prototype.withUser = function (user) {
        this.phoneCallEvent.user = user;
        return this;
    };
    PhoneCallEventBuilder.prototype.withCreationDate = function (creationDate) {
        this.phoneCallEvent.creationDate = creationDate;
        return this;
    };
    PhoneCallEventBuilder.prototype.withInfoValues = function (infoValues) {
        this.phoneCallEvent.infoValues = infoValues;
        return this;
    };
    PhoneCallEventBuilder.prototype.build = function () {
        return this.phoneCallEvent;
    };
    return PhoneCallEventBuilder;
}());
export { PhoneCallEventBuilder };
//# sourceMappingURL=phone-call-event.builder.js.map